module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-5e5c9b2b369dccac3d4196d3a52fdcde.png";